import styles from './Footer.module.css';

export default function FooterComponent() {
    return (
        <footer className={styles.footer + ' section'}>
            &copy; 2024 - Jagdish Chopde - Profile Website
        </footer>
    );
}